import { useState, useEffect } from 'react';
import { connectStateResults } from 'react-instantsearch-dom';

const StateResults = connectStateResults(({
  searchState, setSearchValue,
}: { searchState: any, setSearchValue: Function }) => {
  const [query, setQuery] = useState(searchState.query);

  useEffect(() => {
    setQuery(searchState.query);
  }, [searchState.query]);

  useEffect(() => {
    setSearchValue(query);
  }, [query, setSearchValue]);

  return null;
});

export default StateResults;
